module.exports = __webpack_public_path__ + "img/pay.11cc51a0.png";